import ClientInformationForm from "./ClientInformationForm";

export default ClientInformationForm;
